import React from "react";
import { useSelector } from "react-redux";
import TestimonialCard from "./CommonTemplates/TestimonialCard.jsx";
import Carousel from "./Carousel/Carousel.jsx";
import CollectionSlider from "./FestiveCollection/CollectionSlider.jsx";
import GoogleReviews from "./GoogleReviews/GoogleReviews.jsx";
import TermsCondition from "./TermsCondition/TermsCondition.jsx";
import { useParams } from "react-router-dom";
import { getDomainInfo } from "../utils/utils.js";
import RecentlyViewedSlider from "./RecentlyViewedSlider/RecentlyViewedSlider.jsx";

function HelloTabContent() {
  const customServices = useSelector(
    (state) => state.fetchCollectionInfo?.sellerCollection
  );
  const userid = useSelector((state) => state.fetchUser?.user?.id);

  const testiMonialsMap = [
    {
      label: "Testimonials",
      image:
        "https://static-cse.canva.com/blob/1218532/00gross_IG_hubs_adriansava.jpg",
    },
    {
      label: "Events",
      image:
        "https://static-cse.canva.com/blob/1218532/00gross_IG_hubs_adriansava.jpg",
    },
    {
      label: "Collabs",
      image:
        "https://static-cse.canva.com/blob/1218532/00gross_IG_hubs_adriansava.jpg",
    },
  ];

  return (
    <>
      <div className="d-flex gap-4 justify-content-center">
        {testiMonialsMap.map((item, index) => (
          <div className="col-auto" key={index}>
            {/* <TestimonialCard
              image={item.image}
              label={item.label}
              index={index}
            /> */}
          </div>
        ))}
      </div>

      {userid && <Carousel userId={userid} />}
      <div className="collectionContainer">
      <div className="container">
        {customServices?.length > 0 &&
          customServices.map((item, index) => {
            if (item?.productIds?.length > 0) {
              return <CollectionSlider collectionDetails={item} key={index} />;
            }
          })}
      </div>
      </div>


      <GoogleReviews />

      {userid && <TermsCondition userId={userid} />}
    </>
  );
}

export default HelloTabContent;
